import { useContext } from 'react';
import { HideLayoutContext } from '../providers/hide-layout.js';

const useLayout = () => {
  const {
    hideLayout,
    setHideLayout
  } = useContext(HideLayoutContext);
  return {
    hideLayout,
    setHideLayout
  };
};

export { useLayout };
//# sourceMappingURL=use-layout.js.map
